import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '⚡',
    text: 'Acceso Inmediato'
  }, {
    icon: '🇦🇷',
    text: 'Hecho para Argentinos'
  }, {
    icon: '🔒',
    text: 'Pago Seguro'
  }];
  return <section className="relative bg-black text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-141">
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-142">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-emerald-600/25 blur-[120px]" data-id="element-143"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-green-800/20 blur-[100px]" data-id="element-144"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-145">
        <div className="max-w-4xl mx-auto text-center mt-[-50px]" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-emerald-400 font-bold tracking-wide items-center justify-center mb-6" data-id="element-147">
            🇧🇷 MEGAPACK PORTUGUÉS LISTO™
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 text-emerald-400 text-balance text-[18px]" data-id="element-148">
            Del Español al Portugués Real. Desde Hoy.
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-[280px] sm:max-w-[320px] md:max-w-[400px] lg:max-w-md mx-auto mb-10" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/aAA9UARb6GUkxce9WtQvkz/MOCKUP.png" alt="MEGAPACK PORTUGUÉS LISTO - Sistema completo para argentinos que quieren aprender portugués brasileño" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(16,185,129,0.45)] mt-[-20px]" data-id="element-150" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="md:text-xl font-bold text-emerald-400 mb-6 text-balance text-[14px] mt-[-10px]" data-id="element-151">
            El sistema N°1 para argentinos que quieren hablar portugués
            brasileño real
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-[30px] gap-[6px]" data-id="element-152">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-zinc-900/80 border border-emerald-700/40 font-semibold backdrop-blur-sm text-[12px]" data-id="element-153">
                <span data-id="element-154">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-155">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-emerald-600 hover:bg-emerald-500 text-white font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(16,185,129,0.8)] hover:shadow-[0_15px_50px_-10px_rgba(16,185,129,0.95)] transition-all hover:-translate-y-1 md:text-base text-[12px]" data-id="element-156">
              🔥 QUIERO MI MEGAPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-157" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-300 font-medium" data-id="element-158">
            <div className="flex items-center gap-1.5" data-id="element-159">
              <Shield className="w-4 h-4 text-emerald-400" data-id="element-160" />
              <span data-id="element-161">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-162">
              <Lock className="w-4 h-4 text-emerald-400" data-id="element-163" />
              <span data-id="element-164">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-165">
              <CreditCard className="w-4 h-4 text-emerald-400" data-id="element-166" />
              <span data-id="element-167">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}